<main class="pv2-additional-catalog">
  <header class="pv2-additional-catalog__header">
    <div class="pv2-additional-catalog__heading">
      <button type="button" class="pv2-additional-catalog__back" (click)="goToProducts()"
              [attr.aria-label]="produtoDeOrigem ? 'Voltar para o produto' : 'Voltar para produtos'"
              kendoTooltip [title]="produtoDeOrigem ? 'Voltar para o produto' : 'Voltar para produtos'">
        <span class="fa fa-arrow-left"></span>
      </button>
      <div>
        <span class="pv2-additional-catalog__eyebrow">Catálogo</span>
        <h1>Adicionais</h1>
        <p>Crie uma vez, vincule a vários produtos e mantenha as opções em um só lugar.</p>
      </div>
    </div>

    <button type="button" class="pv2-additional-catalog__primary" (click)="createAdditional()" [disabled]="!canEdit">
      <span class="fa fa-plus"></span>
      Novo adicional
    </button>
  </header>

  <section class="pv2-additional-catalog__stats" *ngIf="!loading">
    <button type="button" [class.is-active]="filter === 'all'" (click)="setFilter('all')">
      <strong>{{ items.length }}</strong>
      <span>Todos</span>
    </button>
    <button type="button" [class.is-active]="filter === 'exclusive'" (click)="setFilter('exclusive')">
      <strong>{{ exclusiveCount }}</strong>
      <span>Exclusivos</span>
    </button>
    <button type="button" [class.is-active]="filter === 'shared'" (click)="setFilter('shared')">
      <strong>{{ sharedCount }}</strong>
      <span>Compartilhados</span>
    </button>
    <button type="button" [class.is-active]="filter === 'unlinked'" (click)="setFilter('unlinked')">
      <strong>{{ unlinkedCount }}</strong>
      <span>Sem vínculo</span>
    </button>
  </section>

  <section class="pv2-additional-catalog__toolbar" *ngIf="!loading">
    <label class="pv2-additional-catalog__search">
      <span class="fa fa-search"></span>
      <input [(ngModel)]="search" type="search" placeholder="Buscar adicional ou produto vinculado">
    </label>
    <span class="pv2-additional-catalog__result-count">
      {{ filteredItems.length }} {{ filteredItems.length === 1 ? 'resultado' : 'resultados' }}
    </span>
  </section>

  <section class="pv2-additional-catalog__loading" *ngIf="loading">
    <span class="fa fa-spinner fa-spin"></span>
    <p>Carregando adicionais...</p>
  </section>

  <section class="pv2-additional-catalog__error" *ngIf="!loading && errorMessage">
    <span class="fa fa-exclamation-circle"></span>
    <div>
      <strong>Não foi possível abrir os adicionais</strong>
      <p>{{ errorMessage }}</p>
      <button type="button" (click)="load()">Tentar novamente</button>
    </div>
  </section>

  <!-- O filtro "Sem vínculo" achava o problema e não oferecia saída; agora diz onde resolver. -->
  <div class="pv2-additional-catalog__aviso"
       *ngIf="!loading && !errorMessage && filter === 'unlinked' && filteredItems.length">
    <span class="fa fa-unlink" aria-hidden="true"></span>
    <p>
      {{ filteredItems.length === 1
          ? 'Este adicional não aparece em nenhum produto.'
          : 'Estes ' + filteredItems.length + ' adicionais não aparecem em nenhum produto.' }}
      Abra um deles para vincular aos produtos.
    </p>
  </div>

  <section class="pv2-additional-list" *ngIf="!loading && !errorMessage && filteredItems.length">
    <div class="pv2-additional-list__head" aria-hidden="true">
      <span>Adicional</span>
      <span>Regra</span>
      <span>Vínculos</span>
      <span>Opções</span>
      <span></span>
    </div>

    <article class="pv2-additional-row"
             *ngFor="let item of filteredItems; trackBy: trackByAdditional"
             tabindex="0"
             role="button"
             (click)="openAdditional(item)"
             (keydown.enter)="openAdditional(item)">
      <div class="pv2-additional-row__identity">
        <span class="pv2-additional-row__icon" [class.is-shared]="item.sharedCount > 1">
          <i class="fa" [ngClass]="item.type === 'single' ? 'fa-dot-circle-o' : 'fa-check-square-o'"></i>
        </span>
        <div>
          <h2>{{ item.name }}</h2>
          <span class="pv2-additional-row__badge" [class.is-optional]="!item.required">
            {{ requirementLabel(item) }}
          </span>
          <button type="button" class="pv2-additional-row__channel-link"
                  *ngIf="temCanalVendaAtivo && item.id"
                  (click)="$event.stopPropagation(); abraPrecosCanais(item)"
                  (keydown.enter)="$event.stopPropagation()">
            <i class="fa fa-tags" aria-hidden="true"></i> Preços por canal
          </button>
        </div>
      </div>

      <div class="pv2-additional-row__cell" data-label="Regra">
        <strong>{{ item.description }}</strong>
        <span>{{ item.type === 'single' ? 'Escolha única' : item.type === 'multipleRepeat' ? 'Múltipla com repetição' : 'Escolha múltipla' }}</span>
      </div>

      <div class="pv2-additional-row__cell" data-label="Vínculos">
        <strong class="pv2-additional-row__scope"
                [class.is-exclusive]="item.sharedCount === 1"
                [class.is-shared]="item.sharedCount > 1"
                [class.is-unlinked]="item.sharedCount === 0">
          {{ usageLabel(item) }}
        </strong>
        <span>{{ usageSupport(item) }}</span>
      </div>

      <div class="pv2-additional-row__options" data-label="Opções">
        <strong>{{ item.optionsCount }}</strong>
        <span>{{ item.optionsCount === 1 ? 'opção' : 'opções' }}</span>
      </div>

      <span class="pv2-additional-row__chevron fa fa-chevron-right" aria-hidden="true"></span>
    </article>
  </section>

  <section class="pv2-additional-catalog__empty" *ngIf="!loading && !errorMessage && !filteredItems.length">
    <span class="fa fa-list-ul"></span>
    <h2>{{ items.length ? 'Nenhum adicional encontrado' : 'Crie seu primeiro adicional' }}</h2>
    <p>{{ items.length ? 'Ajuste a busca ou selecione outro filtro.' : 'Crie o grupo uma vez e escolha em quais produtos ele aparece.' }}</p>
    <button type="button" *ngIf="!items.length" (click)="createAdditional()" [disabled]="!canEdit">Novo adicional</button>
  </section>
</main>

<app-precos-canais-adicional
  *ngIf="temCanalVendaAtivo && precosCanaisAberto && adicionalPrecosCanalId"
  [adicionalId]="adicionalPrecosCanalId"
  (fechou)="fechePrecosCanais()">
</app-precos-canais-adicional>
